export default () => {
    function setWindowHeight() {
        let contentSite = document.getElementsByClassName('main')[0];
        let topbar = document.getElementsByClassName('Topbar')[0];
        let header = document.getElementsByClassName('Header')[0];
        let footer = document.getElementsByClassName('Footer')[0];
        
        if(contentSite) {
          contentSite.style.minHeight=String(window.innerHeight-topbar.clientHeight-header.clientHeight-footer.clientHeight)+"px";
        }
      }
  
      window.addEventListener('resize', setWindowHeight);
      setWindowHeight();
};